import React from "react";

const TransactionContext = React.createContext({
  typeOfTransactions: "",
  invoice: {},
});

export default TransactionContext;
